<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Sổ sách giáo viên" :link="[{ text: 'Cấp học', href: '../teacherDoc' }]" />
      </div>
    </div>
    <div class="d-flex justify-center align-center flex-column">
      <div v-for="academicLevel in activeLevels" :key="academicLevel.id">
        <router-link :to="`/teacherDoc/${academicLevel.type}/teacherCat`" :style="{ textDecoration: 'none' }">
          <v-card class="mb-4" :style="{ width: '400px' }" outlined>
            <v-row class="d-flex justify-center align-center">
              <v-col cols="9">
                <v-col cols="12" class="d-flex flex-row align-center">
                  <div class="ml-4 mr-8">
                    <h2>{{ academicLevel.title }}</h2>
                  </div>
                </v-col>
                <v-col class="mx-4" cols="12">
                  <p>
                    {{ academicLevel.type | gradePerLevel }}
                  </p>
                </v-col>
              </v-col>
            </v-row>
          </v-card>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { mapGetters } from 'vuex'
export default {
  components: {
    Breadcrumbs
  },
  computed: {
    ...mapGetters('auth', ['profile']),
    activeLevels() {
      return this.profile.academicLevels.filter(level => level.status === 'active')
    }
  }
}
</script>

<style scoped></style>
